import { format, formatDistanceToNow, isValid, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const CARRIER_APPLICATIONS_PAGE_SIZE = 20;

function formatLocation(place, fallback = "—") {
  if (!place) return fallback;
  if (typeof place === "string") return place;
  if (place.label) return place.label;
  const city = place.city;
  const uf = place.uf || place.state;
  if (city && uf) return `${city}/${uf}`;
  return city || uf || fallback;
}

function formatFreightNumber(item) {
  if (item.numberSerial != null && item.numberSerial !== "") {
    return String(item.numberSerial);
  }
  const code = item.freightCode;
  if (!code) return "—";
  return String(code).replace(/^FT-/i, "");
}

export function mapCarrierApplicationItem(item) {
  const applicationStatus = String(item.applicationStatus || "").toUpperCase();

  return {
    freightId: item.freightId,
    number: formatFreightNumber(item),
    freightCode: item.freightCode,
    origin: formatLocation(item.origin),
    destination: formatLocation(item.destination),
    collectionDate: item.collectionDate,
    fixedPriceAmount: item.fixedPriceAmount,
    shipperName: item.shipperName || "—",
    applicationStatus,
    applicationStatusLabel:
      item.applicationStatusLabel ||
      (applicationStatus === "ACCEPTED"
        ? "Transportadora aceita"
        : "Aguardando análise"),
    registeredAt: item.registeredAt,
    freightStatusDescribe: item.status?.describe || "",
    canGoToFreightList: item.canGoToFreightList === true,
    isAccepted: applicationStatus === "ACCEPTED",
    isWaiting: applicationStatus === "WAITING",
  };
}

export function parseCarrierApplicationsResponse(response, cursorForPage) {
  const root = response?.data ?? {};
  const items = Array.isArray(root.data) ? root.data : [];
  const pagination = root.pagination ?? {};
  const nextCursor = pagination.nextCursor ?? pagination.next_cursor ?? null;
  const hasMore =
    pagination.hasMore === true &&
    typeof nextCursor === "string" &&
    nextCursor.trim().length > 0 &&
    nextCursor !== cursorForPage;

  return {
    items,
    nextCursor,
    hasMore,
    count: pagination.count ?? items.length,
  };
}

export function formatApplicationDate(value) {
  if (!value) return "—";
  try {
    const date = typeof value === "string" ? parseISO(value) : new Date(value);
    if (!isValid(date)) return "—";
    return format(date, "dd/MM/yyyy", { locale: ptBR });
  } catch {
    return "—";
  }
}

export function formatWaitingSince(value) {
  if (!value) return null;
  try {
    const date = typeof value === "string" ? parseISO(value) : new Date(value);
    if (!isValid(date)) return null;
    return formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
  } catch {
    return null;
  }
}

export function formatCurrency(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(num);
}

export function getApiErrorMessage(error, fallback = "Ocorreu um erro inesperado.") {
  return (
    error?.response?.data?.message ??
    error?.response?.data?.msg ??
    error?.response?.data?.error ??
    error?.message ??
    fallback
  );
}
